var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 25.875C40 34.1593 33.2843 40.875 25 40.875C16.7157 40.875 10 34.1593 10 25.875C10 17.5907 16.7157 10.875 25 10.875C33.2843 10.875 40 17.5907 40 25.875Z",
    fill: "#3B968B",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25.875C49 39.1298 38.2548 49.875 25 49.875C11.7452 49.875 1 39.1298 1 25.875C1 12.6202 11.7452 1.875 25 1.875C38.2548 1.875 49 12.6202 49 25.875Z",
    stroke: "#3B968B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.2e9113330db3bd93f479d39a5748d5d2.svg";
export { ForwardRef as ReactComponent };